import React, {Fragment, SyntheticEvent, useState} from 'react';
import IconButton from "@mui/material/IconButton";
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  ListItemIcon,
  Menu, ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useForm} from "react-hook-form";
import {MensajesRequestFields} from "../../api/schemas";
import {useSistemasPrincipales} from "../../api/useSistemasPrincipales";
import Stack from "@mui/system/Stack";
import {useSistemas} from "../../api";
import {AvatarSistema, AvatarSistemaPrincipal} from "./AvatarSistemaPrincipal";
import Button from "@mui/material/Button";
import {ControlledDatePicker, ControlledTextField} from "../../../../components/forms";
import {SchemaFiltroMensajeType} from '../../Messages';
import {HttpCacheWorkflow} from "../../../../http/workflow/httpCacheWorkflow";
import {EtapaEstado, EtapaEstadosFields} from "../../../../types/workflow/cache";
import {EntityWithIdAndDescriptionFields} from "../../../../types";
import {Icon} from "@iconify/react";
import {ControlledAutocomplete} from "../../../../components/forms/ControlledAutocomplete";
import {ChipTag} from "../desktop/MessagesDesktop";

type MessageFilterDropDownProps = {
  form: ReturnType<typeof useForm<SchemaFiltroMensajeType>>
}

function MessageFilterDropdown({form}: MessageFilterDropDownProps) {
  const {sistemasPrincipal} = useSistemasPrincipales();
  const {sistemas} = useSistemas();
  const watchIsResponsible = form.watch(MensajesRequestFields.IsResponsible);

  const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null)

  const handleDropdownOpen = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget)
  }

  const handleDropdownClose = () => {
    setAnchorEl(null)
  }
  
  const onChangeToggleResponsible = (_: React.MouseEvent<HTMLElement>, value: boolean) =>
    form.setValue(MensajesRequestFields.IsResponsible, value)

  return (
    <Fragment>
      <IconButton color='inherit' aria-haspopup='true' onClick={handleDropdownOpen}
                  aria-controls='customized-menu'>

        <FilterListIcon/>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleDropdownClose}
        sx={{
          minWidth: '100%',
          '& .MuiList-root': {padding: 0}
        }}
      >
        <MenuItem
          disableRipple
          disableTouchRipple
          sx={{
            py: 3.5,
            cursor: 'default',
            userSelect: 'auto',
            backgroundColor: 'transparent !important',
            borderBottom: theme => `1px solid ${theme.palette.divider}`
          }}
        >
          <Button
            sx={{py: 0, px: 2}}
            onClick={() => form.reset()}
          >
            Limpiar Filtros
          </Button>
        </MenuItem>


        <Accordion key={'acc-referencia'} disableGutters sx={{boxShadow: 0}}>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            Id
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <ControlledTextField
              label='Id'
              control={form.control}
              fullWidth
              name={MensajesRequestFields.IdMensaje}
              numeric
            />
          </AccordionDetails>
        </Accordion>

        <Accordion key={'acc-pais'} disableGutters
                   sx={{minWidth: '60vw'}}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            País
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <Stack direction={'row'} gap={2}>
              {
                sistemasPrincipal?.map((sist, index) => (
                  <Checkbox
                    key={index}
                    inputProps={{...form.register(MensajesRequestFields.CodsSistemaPrincipal)}}
                    sx={{padding: 0}}
                    icon={<AvatarSistemaPrincipal sistemaPrincipal={sist}/>}
                    checkedIcon={<AvatarSistemaPrincipal sistemaPrincipal={sist} isSelected/>}
                    checked={form.watch(MensajesRequestFields.CodsSistemaPrincipal).includes(sist.id)}
                    value={sist.id}

                  />

                ))
              }

            </Stack>
          </AccordionDetails>
        </Accordion>

        <Accordion key={'acc-sistema'} disableGutters sx={{boxShadow: 0}}>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            Circuito
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <Stack direction={'row'} gap={2}>
              {
                sistemas?.map((sist, index) => (
                  <Checkbox
                    key={index}
                    sx={{padding: 0}}
                    inputProps={{...form.register(MensajesRequestFields.CodTipoMensaje)}}
                    icon={<AvatarSistema sistema={sist}/>}
                    checkedIcon={<AvatarSistema sistema={sist} isSelected/>}
                    checked={form.watch(MensajesRequestFields.CodTipoMensaje).includes(sist.id)}
                    value={sist.id}
                  />
                ))
              }
            </Stack>
          </AccordionDetails>
        </Accordion>

        <Accordion key={'acc-referencia'} disableGutters sx={{boxShadow: 0}}>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            Referencia
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <ControlledTextField
              label='Referencia'
              control={form.control}
              fullWidth
              name={MensajesRequestFields.Referencia}
              variant={'standard'}
            />
          </AccordionDetails>
        </Accordion>


        <Accordion key={'acc-fecha'} disableGutters sx={{boxShadow: 0}}>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            Fecha
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <Stack direction={'row'} gap={2}>
              <ControlledDatePicker
                label='Desde'
                control={form.control}
                fullWidth
                name={MensajesRequestFields.FechaDesde}
                clearable
                mobile
              />
              <ControlledDatePicker
                label='Hasta'
                control={form.control}
                fullWidth
                name={MensajesRequestFields.FechaHasta}
                clearable
                mobile
              />
            </Stack>
          </AccordionDetails>
        </Accordion>

        <Accordion key={'acc-estado'} disableGutters sx={{boxShadow: 0}}>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}
                            sx={{
                              margin: 0,
                            }}
          >
            Estado
          </AccordionSummary>
          <AccordionDetails sx={{pb: 1}}>
            <ControlledAutocomplete
              label='Estado'
              name={MensajesRequestFields.Estados}
              control={form.control}
              multiple
              valueField='id'
              loadOptions={HttpCacheWorkflow.getEtapaEstados}
              TagComponent={(value: EtapaEstado) => {
                return (props: any) => (
                  <ChipTag
                    label={value[EntityWithIdAndDescriptionFields.Description]}
                    color={value[EtapaEstadosFields.HexColor]}
                    {...props}
                  />
                )
              }}
              renderOption={(renderProps, value: EtapaEstado, state) => {
                return (
                  <MenuItem
                    key={state.index}
                    selected={state.selected}
                    value={value.id}
                    {...renderProps}
                  >
                    <ListItemIcon>
                      <Icon
                        icon='mdi:circle'
                        color={value[EtapaEstadosFields.HexColor]}
                        fontSize='1rem'
                      />
                    </ListItemIcon>
                    {value.descripcion}
                  </MenuItem>
                )
              }}
            />
          </AccordionDetails>
        </Accordion>

        <Box px={8} py={1} sx={{ borderTop: theme => `1px solid ${theme.palette.divider}` }}>
          <ToggleButtonGroup size={'small'}
                             exclusive
                             color='primary'
                             value={watchIsResponsible}
                             onChange={onChangeToggleResponsible}
                             sx={{ height: '-webkit-fill-available', width: '100%' }}
          >
            <ToggleButton value={true} sx={{ width: '100%' }}>Mis Pendientes</ToggleButton>
            <ToggleButton value={false} sx={{ width: '100%' }}>Todos</ToggleButton>
          </ToggleButtonGroup>
        </Box>
        
        <MenuItem
          disableRipple
          disableTouchRipple
          sx={{
            borderBottom: 0,
            cursor: 'default',
            userSelect: 'auto',
            backgroundColor: 'transparent !important',
            borderTop: theme => `1px solid ${theme.palette.divider}`,
            px: 5,
          }}
        >
          {/* <ControlledSwitch
                        label={'En Curso'}
                        name={MensajesRequestFields.EnCurso} control={form.control}
                    /> */}
        </MenuItem>
      </Menu>
    </Fragment>
  );
}

export default MessageFilterDropdown;
